
Wf = {
  debounce: function (func, wait, immediate) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later   = function () {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  },
  
  /** Функция поочередной анимации элементов на странице
   *  @param {obj} $obj - jQuery-коллекция элементов, к которым нужно применить эффект
   *  @param {string} effect - класс, который будет применен к элементам
   *  @param {int} delay - задержка между применениями элементов, в миллисекундах
   */
  toggleForm: function ($form, classFields, classThanks) {
    if (classFields === undefined) {
      classFields = '.form-fields';
    }
    if (classThanks === undefined) {
      classThanks = '.form-thanks';
    }
    var $fields = $form.find(classFields), //поля
        $thanks = $form.find(classThanks), //спасибо
        $tohide = $fields,
        $toshow = $thanks;
    
    if ($thanks.is(':visible')) {
      $toshow = $fields;
      $tohide = $thanks;
    }
    
    $tohide.fadeOut(150);
    setTimeout(function () {
      $toshow.fadeIn(300);
    }, 151);
    
    return $form;
  },
  
  /**resetForm - возвращение формы к первоначальному состоянию: очистка всех инпутов, удаление всех классов валидации,
   * скрытие сообщения об успехе и отображение инпутов.
   * @param {object} $form - форма
   * @param {string} classFields - селектор блока-контейнера полей формы
   * @param {string} classThanks - селектор блока с сообщением об успешной доставки
   * */
  resetForm: function ($form, classFields, classThanks) {
    if ($form === undefined) {
      return false;
    }
    if (classFields === undefined) {
      classFields = '.form-fields';
    }
    if (classThanks === undefined) {
      classThanks = '.form-thanks';
    }
    var $inputs = $form.find('input, textarea'); //инпуты (будем чистить)
    
    $inputs.removeClass('valid').addClass('empty').val('');
    $(classThanks).hide();
    $(classFields).show();
  },
  
  /** checkVisibility - проверяет на видимость элементы страницы (в зависимости от скроллинга)
   * @param {object} $target - элемент
   * @return bool
   * */
  checkVisibility: function ($target) {
    if ($target === undefined) {
      return false;
    }
    var offsetTarget = $target.offset().top,
        offsetPage   = window.pageYOffset + window.innerHeight;
    
    return (offsetTarget < offsetPage);
  },
  /*Анимированое появление блоков при скроллинге*/
  scrollAnimate: function ($obj) {
    if ($obj === undefined) {
      return false;
    }
    
    var animFunc = function () {
      $obj.each(function (e) {
        var $item = $(this);
        if ($item.is(':not(.in)')) {
          if (WfFunc.checkVisibility($item)) {
            $item.addClass('in');
          }
        }
      });
    };
    animFunc();
    $(window).on('scroll', animFunc);
  },
  /**slowScroll - плавная анимация по странице
   * @param {string} target - id целевого элемента
   * @param {number} scrolltime - скорость прокрутки (в миллисекундах)
   * @return {object}
   * */
  slowScroll: function (target, scrolltime, correct) {
    
    if ($(target) === undefined) {
      return false;
    }
    
    var offsetTarget,
        time     = 400,
        corr     = 0,
        $t       = $(target),
        offset;
    
    if (correct !== undefined) {
      corr = correct;
    }
    
    if (!$t.length) {
      return false;
    }
    
    if (scrolltime !== undefined) {
      time = scrolltime;
    }
    if ($(target).data('correct') !== undefined) {
      corr = $(target).data('correct');
    }
    
    offset = $t.offset().top - corr;
    $("body,html").animate({"scrollTop": offset}, time);
    
    return $(target);
  },
  wfToggle: function ($link) {
    var t,
        $target;
    
    if ($link.attr('href') !== undefined) {
      t = $link.attr('href');
    }
    else {
      t = $link.data('target');
    }
    $target = $(t);
    
    if (!$target.length) {
      return false;
    }
    if ($target.is(':visible')) {
      $target.fadeOut(250);
      $link.removeClass('on');
    }
    else {
      $target.fadeIn(250);
      $link.addClass('on');
    }
    return $link;
  },
  classes: {
    d: {
      popup: 'wf-popup',
      showClass: 'open',
      visibleClass: 'in'
    },
    toggle: function ($menu) {
      if ($menu.is('.' + this.d.visibleClass)) {
        this.hide($menu);
      }
      else {
        this.show($menu);
      }
    },
    show: function ($menu) {
      var $pp  = $menu,
          defs = this.d;
      if ($menu === undefined) {
        $pp = $(defs.popup);
      }
      $pp.addClass(defs.showClass);
      setTimeout(function () {
        $pp.addClass(defs.visibleClass);
      }, 50);
    },
    hide: function ($menu, time) {
      var $pp  = $menu,
          defs = this.d;
      if ($menu === undefined) {
        $pp = $(defs.popup);
      }
      if (time === undefined) {
        time = 300;
      }
      
      $pp.removeClass(defs.visibleClass);
      setTimeout(function () {
        $pp.removeClass(defs.showClass);
      }, time);
    }
  },
  /**
   * submitForm - отправка форм аяксом с предварительной сериализацией данных. В случае успешной отправки вызывает переключение формы Wf.toggleForm();
   * @function
   * @param {object} $form - jQuery-объект формы
   * */
  submitForm: function($form) {
    if ($form === undefined) {
      return false;
    }
    var $f = $form,
        f_data = $f.serialize(),
        f_url = $f.attr('action'),
        f_method = $f.attr('method');
  
    $.ajax({
      url: f_url,
      method: f_method,
      data: f_data,
      success: function(res) {
        Wf.toggleForm($f);
        if ($f.parents('.wf-popup')) {
          setTimeout(function(){
            $.magnificPopup.close();
          }, 3500);
        }
      },
      error: function(res) {
        console.log('Error');
        console.log(res);
      }
    });
  },
  /**Стилизация файловых инпутов
   * @param {nodeList} inputs - список файловых инпутов
   * @param {string} -
   * */
  fileStyling: function(inputs) {
    var defs = {
      defaultText: "Выберите файл",
      wrapperClass: 'input-file',
      captionClass: 'input-file__caption',
      activeClass: 'active',
      inputStyles: {
        opacity: 0,
        display: 'block',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        cursor: 'pointer',
        'z-index': '100',
        'font-size' : '150px',
        
      },
      wrapperStyles : {
        position: 'relative',
        width: '100%',
        height: '50px',
        display: 'flex',
        cursor: 'pointer',
        overflow: 'hidden',
        'align-items': 'center'
      }
    };
  
    if (arguments[1] !== undefined)
      defs.defaultText = arguments[1];
    
    var prepareStyles = function(obj) {
      if (typeof obj === 'object') {
        var str = JSON.stringify(obj);
        str = str.slice(0, -1);
        str = str.slice(1, str.length);
        str = str.replace(/"/g,'');
        str = str.replace(/\,/g, ';');
        return str;
      }
    };
    var buildInput = function(input) {
      var parent = input.parentNode,
          inputWrapper = document.createElement('div'),
      inputCaption = document.createElement('span');
      
      inputCaption.classList.add(defs.captionClass);
      inputCaption.innerText = defs.defaultText;
  
      //добавляем базовые стили
      inputWrapper.style.cssText = prepareStyles(defs.wrapperStyles);
      input.style.cssText = prepareStyles(defs.inputStyles);
      
      inputWrapper.classList.add(defs.wrapperClass);
      inputWrapper.appendChild(input);
      inputWrapper.appendChild(inputCaption);
      
      parent.appendChild(inputWrapper);
  
      input.addEventListener('change', function(){
        var path = this.value;
        if (path !== undefined && path !== '') {
          inputCaption.innerText = parseFileName(path);
          inputCaption.classList.add(defs.activeClass);
        }
        else {
          inputCaption.classList.remove(defs.activeClass);
        }
      });
    };
    
    var parseFileName = function(str) {
      var fileName = defs.defaultText;
      if (str.length) {
        var fileArr;
        if (str.indexOf('/') + 1)
           fileArr = str.split('/');
        else
           fileArr = str.split('\\');
        
        fileName = fileArr[fileArr.length - 1];
      }
      return fileName;
    };
    
    
    if (inputs === undefined)
      return false;
    
    for (var i = 0; i < inputs.length; i++) {
      buildInput(inputs[i]);
    }
  },
  /**Склонение числительны.
   * @param {number} number - числительное
   * @param {array} titles - словоформы
   * @return {string} title - возвращает требуемую словоформу
   * */
  numerals: function (number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
  }
};
